<template>
<BaseDialog
        :showDialog="showImageUploadDialog"
        maxDialogWidth="800"
        maxCardHeight="600"
        :headline="headline"
        :close="closeDialog"
        :alvqa="alvqa"
    >
    <!-- IF THERE WAS NO COVER PICTURE AND THE USER WANTS TO UPLOAD A PICTURE -->
    <template v-slot:dialogText> 
        <!-- DRAG AND DROP  -->
        <v-container fluid> 
                <v-row>
                    
                    <v-col v-if='!showCropper && !pictureExists' :alvqa="alvqa + '-drag-and-drop' ">
                        <VueFileAgent
                            ref="imageUploader"
                            v-model="selected"
                            :thumbnailSize="800"
                            :compact="false"
                            :theme="'grid'"
                            :accept="'image/*'"
                            :multiple="false"
                            :deletable="true"
                            :maxFiles="1"
                            :meta="false"
                            :errorText="errorProps"
                            @beforedelete="removeImage($event)"
                            @select="imageSelected($event)"
                            :averageColor="true"
                            :helpText="$t('lang_GENERAL_PICTURE_UPLOADER_TEXT')"
                        >
                        </VueFileAgent>
                    </v-col>
                <!-- CROPPER -->
                    <v-col v-if="showCropper" :alvqa="alvqa + '-image-cropper'">
                        <vue-cropper
                            ref="cropper"
                            :src="imgSrc"
                            alt="Selected Image"
                            :autoCropArea=".9"
                            :dragMode="'none'"
                            :scalable="false"
                            :zoomable="false"
                        ></vue-cropper>
                </v-col>
                <!-- IMAGE -->
                <v-col v-if="pictureExists" :alvqa="alvqa + '-image'">
                        <v-img
                          :src="imageURL">
                        </v-img>
                </v-col>

             </v-row>
        </v-container> 
        
     </template>

 <!-- DRAG AND DROP => EDIT && UPLOAD BUTTONS -->
    <template v-slot:dialogActions>
        <v-container>
                <v-row>
                    <v-spacer></v-spacer>
                    <!-- <v-col class="text-right d-flex justify-end" align-self="center" cols="3"> -->
                    <v-col class="d-flex justify-end" cols="9" align-self="center">
                        <BaseButton 
                            :disabled="!showEditBtn"
                            v-if="!showCropper && !pictureExists"
                            label="lang_GENERAL_CAPTION_ICON_EDIT"
                            @click="openCropper()"
                            :alvqa="alvqa+'-button-edit'"
                        />
                        <BaseButton 
                            v-if="pictureExists"
                            label="lang_GENERAL_CAPTION_ICON_EDIT"
                            @click="editExistingPicture()"
                            :alvqa="alvqa+'-button-edit'"
                        />
                        <BaseButton 
                            v-if="showCropper"
                            :label="isAzModules ? 'lang_GENERIC_CAPTION_CHANGE_IMAGE' : 'lang_GENERIC_CAPTION_CHANGE_LOGO'"
                            @click="removeImage(selected)"
                            :alvqa="alvqa+'-button-new-change-logo'"
                        />   
                    </v-col>
                    <v-col class="d-flex justify-end pl-0" align-self="center">
                        <BaseButton
                            v-if="!pictureExists" 
                            :disabled="!showImageUploadButton"
                            label="lang_GENERAL_CAPTION_UPLOAD"
                            @click="uploadImage()"
                            :alvqa="alvqa+'-button-image-upload'"
                        />
                        <BaseButton 
                            v-if="pictureExists"
                            label="lang_GENERIC_CAPTION_DELETE"
                            @click="deleteExistingPicture()"
                            :alvqa="alvqa+'-button-image-delete'"
                        />    
                    </v-col>
                </v-row>
        </v-container>
    
    </template>
</BaseDialog>

</template>

<script>

import BaseDialog from '@/components/_base/BaseDialog'
import BaseButton from '@/components/_buttons/BaseButton'
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
import api from '@/api_alv'

export default {
    name: "ImageUploadDialog",
    props:{
        headline:{
            type: String
        }
    },
    components:{
        BaseDialog,
        BaseButton,
        VueCropper
    },
    data(){
        return {
            alvqa : "image-upload-dialog",
            showCropper:false,
            showImageUploadButton:false,
            cropImg:'',
            formData: new FormData(),
            showEditBtn:false,
            imgSrc: '',
            errorProps: {
                type:this.$t('lang_GENERIC_DRAG_AND_DROP_UPLOADER_WRONG_FILE_FORMAT'),
                size: 'You selected a larger file!',
            },
        }
    },
    computed: {
        showImageUploadDialog: {
            get() { return this.$store.getters.getShowImageUploadDialog },
            set(show) { this.$store.commit('setShowImageUploadDialog', show) }
        },
        selected: {
            get() { return this.$store.getters.getSelectedImageUploadFile },
            set( item ) { this.$store.commit('setSelectedImageUploadFile', item)},
        },
        pictureExists:{
            get() { return this.$store.getters.getImageUploaderImageExists },
            set( item ) { this.$store.commit('setImageUploaderImageExists', item)},
        },
        dialogContext:{
            get() { return this.$store.getters.getImageUploaderContext },
            set( context ) { this.$store.commit('setImageUploaderContext', context)},
        },
        imageURL:{
            get() { return this.$store.getters['get' + this.dialogContext + 'ImageUrl'] },
            set( url ) { this.$store.commit('set' + this.dialogContext + 'ImageUrl', url)},
        },
        isAzModules() {
               return ["AzGroups", "AzPersons"].includes(this.dialogContext);
        },
    },

    methods:{
        closeDialog() {
            this.showImageUploadDialog = false
            this.showImageUploadButton = false
            this.pictureExists = false
            this.showCropper=false
            this.showEditBtn =false
            this.imgSrc = ''
            this.selected = null

            if(this.$refs.cropper !== undefined){
                this.$refs.cropper.destroy()
            }
        },
        removeImage(image){
            this.showImageUploadButton = false
            this.showCropper = false
            this.showEditBtn = false
            if(this.$refs.imageUploader !== undefined){
                this.$refs.imageUploader.deleteFileRecord(image);
            }
            this.selected = null
            
        },

        imageSelected(image){
            //If the immage passes validation it will be shown in preview
            //Buttons will be activated 

            if(image[0].error === false){
                this.selected = image
                this.showImageUploadButton = true
                this.showEditBtn =true
            }
        },

        editExistingPicture(){
            this.imgSrc = this.imageURL
            this.showCropper = true
            this.pictureExists = false;
            this.showImageUploadButton = true
        },
        async openCropper(){

            //For temporary upload API Call in order to be able to crop the image 
            let dir ="images/temporary/"
            let selectedImage = this.selected[0]

            //Sending to BE for temporary save and getting path of Img for cropp
            this.formData.append('file',JSON.stringify(selectedImage))  
            let tempUpload = await api.putFile(dir, this.formData)
            this.showCropper = true
            this.imgSrc = tempUpload.response.path

        },

        async deleteExistingPicture() {
                this.removeImage();
                this.imageURL = null;
                this.pictureExists = false;
                if (!this.isAzModules) {
                    this.$store.commit('setSnackbar', {
                        type: 'success',
                        msg: this.$t('lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON')
                    });
                } else {
                    await this.$store.dispatch("save" + this.dialogContext + "Form");
                    await this.$store.dispatch("fetch" + this.dialogContext);
                }
            },
  
        async uploadImage(){
            // Sending a cropped image to BE
            let alvId = this.isAzModules
                ? this.$store.getters["get" + this.dialogContext + "Details"].alvId
                : this.$store.getters["getSelected" + this.dialogContext].alvId;
            let dir ='images/' + alvId
            let response = ''

            //Sending a cropped picture
            if(this.showCropper){
                this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
                this.formData.append('file',this.cropImg)
                response = await api.putFile(dir,this.formData)
            }else{
                //Sending not cropped picture
                this.formData.append('file',JSON.stringify(this.selected[0]))
                response = await api.putFile(dir, this.formData)

            }

            this.imageURL = response.response.path
            if (this.isAzModules) {
                await this.$store.dispatch("save" + this.dialogContext + "Form");
                await this.$store.dispatch("fetch" + this.dialogContext);
            }

            this.closeDialog();
            if (!this.isAzModules) {
                this.$store.commit("setSnackbar", {
                type: "success",
                msg: this.$t("lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON"),
                });
            }
        }
    },
}

</script>

<style>

</style>